import { type SiteTraits } from '../personalization/types';

export const FETCH_PERSONALIZATION_SITE_TRAITS = 'FETCH_PERSONALIZATION_SITE_TRAITS';
export type FetchPersonalizationSiteTraitsAction = {
	type: typeof FETCH_PERSONALIZATION_SITE_TRAITS;
};
export const fetchPersonalizationSiteTraits = (): FetchPersonalizationSiteTraitsAction => ({
	type: FETCH_PERSONALIZATION_SITE_TRAITS,
});

export const FETCH_PERSONALIZATION_SITE_TRAITS_FAILED = 'FETCH_PERSONALIZATION_SITE_TRAITS_FAILED';
export type FetchPersonalizationSiteTraitsFailedAction = {
	type: typeof FETCH_PERSONALIZATION_SITE_TRAITS_FAILED;
};
export const fetchPersonalizationSiteTraitsFailed =
	(): FetchPersonalizationSiteTraitsFailedAction => ({
		type: FETCH_PERSONALIZATION_SITE_TRAITS_FAILED,
	});

export const UPDATE_PERSONALIZATION_SITE_TRAITS = 'UPDATE_PERSONALIZATION_SITE_TRAITS';
export type UpdatePersonalizationSiteTraitsAction = {
	type: typeof UPDATE_PERSONALIZATION_SITE_TRAITS;
	traits?: SiteTraits[];
};
export const updatePersonalizationSiteTraits = (
	traits?: SiteTraits[],
): UpdatePersonalizationSiteTraitsAction => ({
	type: UPDATE_PERSONALIZATION_SITE_TRAITS,
	traits,
});
